import { Dropdown } from 'j-comps'
import { theme } from 'j-comps'
import MoreVertIcon from '@mui/icons-material/MoreVert'
import OpenInNewIcon from '@mui/icons-material/OpenInNew'
import DeleteIcon from '@mui/icons-material/Delete'
import styled from '@emotion/styled'
import { deleteDesign } from '../../../../../../../../data/actions'
import config from '../../../../../../../../config'

const ViewSpan = styled.span`
  display: flex;
  align-items: center;
  border-radius: 5px;
  color: ${theme.color[config.app].primary};
  padding: 5px 10px;
`

const Text = styled.span`
  margin-left: 5px;
`

const DeleteSpan = styled.span`
  display: flex;
  align-items: center;
  background: red;
  border-radius: 5px;
  color: white;
  padding: 5px 10px;
`

const ActionDropdown = ({ design }) => {
  return (
    <Dropdown
      appName={config.app}
      dropdownButton={{ icon: <MoreVertIcon /> }}
      externalLinks={[
        {
          text: (
            <ViewSpan>
              <OpenInNewIcon />
              <Text>View</Text>
            </ViewSpan>
          ),
          href: design.url,
        },
      ]}
      middleItems={[
        {
          text: (
            <DeleteSpan>
              <DeleteIcon />
              <Text>Delete</Text>
            </DeleteSpan>
          ),
          onClick: () => deleteDesign(design.key),
        },
      ]}
    />
  )
}

export default ActionDropdown
